import {InfoOutlined} from '@ant-design/icons'
import MessagePane from './MessagePane.jsx'

export default () => {
    return {
        icon: <InfoOutlined />,
        key: 'message',
        name: '消息',
        pane: <MessagePane />,
    }
}
